module.exports = __webpack_public_path__ + "img/empty-photo.6f5fd757.svg";